// Module
var code = "<p>Owner permissions define who has control over the account. Owners may overwrite all keys and change any account settings.</p> <p>See <a href=\"accounts/permissions\">permissions</a> for more details.</p> ";
// Exports
export default code;